import React from "react";
import { useTrail, animated } from "react-spring";
import "./Goo.css";

const fast = { tension: 1200, friction: 40 };
const slow = { mass: 10, tension: 200, friction: 50 };
const trans = (x, y) => `translate3d(${x}px,${y}px,0) translate3d(-50%,-50%,0)`;
const Goo = (props) => {
  const [trail, set] = useTrail(3, () => ({
    xy: [props.center[0], props.center[1]],
    config: (i) => (i === 0 ? fast : slow),
  }));
  return (
    <>
      <svg style={{ position: "absolute", width: "100%", height: "100%" }}>
        <filter id="goo">
          <feGaussianBlur in="SourceGraphic" result="blur" stdDeviation="0" />
          <feColorMatrix
            in="blur"
            values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 30 -7"
          />
        </filter>
      </svg>
      <div
        data-testid="goo"
        className="hooks-main"
        onMouseMove={(e) => set({ xy: [e.clientX, e.clientY] })}
      >
        {trail.map((trailProps, index) => (
          <animated.div
            key={index}
            data-testid={`trail-${index}`}
            style={{ transform: trailProps.xy.interpolate(trans) }}
          />
        ))}
      </div>
    </>
  );
};

export default Goo;
